/* ═══════════════════════════════════════════════════════════════════════
   assets/quiz-result-dfco-walk.js

   DFCo Walk Diagnostic — result-page runtime. Vanilla JS, IIFE-scoped.
   Two jobs only (personalization is handled by quiz-result-personalization.liquid):

     1. CTA hand-off (brief §5): stamp every offer CTA's PDP link with
        utm_source / utm_medium / utm_content=<result_type> + result_type, and
        (optionally) forward inbound utm_campaign / utm_term. Done on load so
        middle-click / open-in-new-tab carry the params too.

     2. Analytics (brief §7): fire result_view on load and cta_click on tap to
        the same webhook / Meta Pixel / GA4 destinations the quiz tracker uses.

   Config comes from data-* attributes on [data-quiz-result].
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-quiz-result]');
    if (!root) return;

    var params = new URLSearchParams(window.location.search);
    var resultType = params.get('result_type') || '';

    var cfg = {
      utmSource: root.dataset.utmSource || 'quiz',
      utmMedium: root.dataset.utmMedium || 'walk_diagnostic',
      forwardUtm: root.dataset.forwardUtm === 'true',
      trackEnabled: root.dataset.trackEnabled === 'true',
      webhook: root.dataset.webhook || '',
      metaPixel: root.dataset.metaPixel === 'true',
      ga4: root.dataset.ga4 === 'true'
    };

    // 1. Stamp every CTA → PDP link (on load, so all open methods carry params).
    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-cta]'));
    ctas.forEach(function (a) {
      var base = a.getAttribute('href') || '/';
      a.setAttribute('href', buildPdpUrl(base, resultType, cfg, params));

      a.addEventListener('click', function () {
        track('cta_click', {
          result_type: resultType,
          destination_url: a.href,
          product: nearestProductName(a)
        }, cfg);
      });
    });

    // 2. result_view on load.
    track('result_view', { result_type: resultType }, cfg);
  }

  function buildPdpUrl(base, resultType, cfg, inbound) {
    var isRelative = base.indexOf('/') === 0 && base.indexOf('//') !== 0;
    var url;
    try { url = new URL(base, window.location.origin); }
    catch (e) { url = new URL('/', window.location.origin); }

    // Quiz attribution (brief §5) — set explicitly, overriding any inbound source/medium.
    url.searchParams.set('utm_source', cfg.utmSource);
    url.searchParams.set('utm_medium', cfg.utmMedium);
    if (resultType) {
      url.searchParams.set('utm_content', resultType);
      url.searchParams.set('result_type', resultType);
    }

    // Forward non-conflicting inbound dimensions so the original campaign still attributes.
    if (cfg.forwardUtm) {
      ['utm_campaign', 'utm_term'].forEach(function (k) {
        var v = inbound.get(k);
        if (v) url.searchParams.set(k, v);
      });
    }

    return isRelative ? (url.pathname + url.search + url.hash) : url.toString();
  }

  function nearestProductName(a) {
    var card = a.closest('.qrdfw-card--offer');
    if (!card) return '';
    var pn = card.querySelector('.qrdfw-offer__product-name');
    return pn ? pn.textContent.trim() : '';
  }

  function track(eventType, data, cfg) {
    var payload = Object.assign({
      quiz: 'walk_diagnostic',
      device: /Mobi|Android/i.test(navigator.userAgent) ? 'mobile' : 'desktop',
      ts: new Date().toISOString()
    }, data || {});

    if (!cfg.trackEnabled) return;

    if (cfg.webhook) {
      try {
        var img = new Image();
        img.src = cfg.webhook + (cfg.webhook.indexOf('?') === -1 ? '?' : '&') +
          'event=' + encodeURIComponent('quiz_' + eventType) +
          '&data=' + encodeURIComponent(JSON.stringify(payload)) +
          '&t=' + Date.now();
      } catch (e) {}
    }
    if (cfg.metaPixel && typeof window.fbq === 'function') {
      try { window.fbq('trackCustom', 'Quiz_' + eventType, payload); } catch (e) {}
    }
    if (cfg.ga4 && typeof window.gtag === 'function') {
      try { window.gtag('event', 'quiz_' + eventType, payload); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();